/**
 * Noun for a toast sentence. "Inscriptions" reads as a plural noun in prose;
 * a ticker such as DMT-NAT is a name and keeps its case.
 */
export function listingNoun(classification: string): string {
	return ['Inscriptions', 'Runes', 'Alkanes'].includes(classification)
		? classification.toLowerCase()
		: classification
}
